import { useTranslation } from 'react-i18next';
import { useUi } from '../app/ui';

// EN/AR toggle (mockup toggleLang): sets document dir/lang, i18n language and AntD direction (via App.tsx ConfigProvider).
export function LangSwitch() {
  const { t } = useTranslation();
  const lang = useUi((s) => s.lang);
  const setLang = useUi((s) => s.setLang);
  const next = lang === 'en' ? 'ar' : 'en';
  return (
    <button type="button" id="langBtn" className="lang" lang={next} onClick={() => setLang(next)}>
      {lang === 'en' ? t('topbar.lang.switchToAr') : t('topbar.lang.switchToEn')}
    </button>
  );
}
